import * as React from 'react';
import { TodoState, VovClient } from '../../../ApiOld/ApiServerVov';
import { Box, CircularProgress, Grid } from '@mui/material';
import { useCallback, useImperativeHandle } from 'react';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import MobileRequestBuildingItem from './Components/MobileRequestBuildingItem';
import LoadingIndicator from '../Shared/LoadingIndicator';
import { EmployeeMobileRequestsVovClient, RequestResponseWithBuildingDTO } from '../../../ApiOld/Api/ApiServerVov';
import MobileRequestSearch from './Components/MobileRequestSearch';
import { t } from 'i18next';

export interface IMobileRequestsDetailTabProps {
    state: TodoState;
    setUnreadCount: (count: number) => void;
}

export interface IMobileRequestsDetailTabRef {
    refreshData: () => void;
}

const MobileRequestsDetailTab = React.forwardRef<IMobileRequestsDetailTabRef, IMobileRequestsDetailTabProps>(
    (props, ref) => {
        const { state, setUnreadCount } = props;
        const [requests, setRequests] = React.useState<Record<string, RequestResponseWithBuildingDTO[]>>({});
        const [requestsAll, setRequestsAll] = React.useState<Record<string, RequestResponseWithBuildingDTO[]>>({});
        const [pageSize, setPageSize] = React.useState<number>(1000);
        const [page, setPage] = React.useState<number>(0);

        const [loading, setLoading] = React.useState<boolean>(false);

        const { authorizedMobileEmployeeApi } = useMobileApi(EmployeeMobileRequestsVovClient);

        const refreshData = useCallback(() => {
            setLoading(true);
            authorizedMobileEmployeeApi.getAllRequestsEmployeeMobile(state, pageSize, (pageSize * page)).then((res) => {
                setRequests(groupByBuilding(res?.requests ?? []));
                setRequestsAll(groupByBuilding(res?.requests ?? []));
                setLoading(false);
                setUnreadCount(res?.requests?.reduce((sum, item) => sum + (item.unreadMessages ?? 0), 0) ?? 0);
            }).catch((err) => {
                console.error(err);
                setLoading(false);
                setUnreadCount(0);
            });
        }, [authorizedMobileEmployeeApi, state, pageSize, page]);

        function groupByBuilding(data: RequestResponseWithBuildingDTO[]): Record<string, RequestResponseWithBuildingDTO[]> {
            return data.reduce((groups, item) => {
                const { buildingName } = item;
                if (!groups[buildingName!]) {
                    groups[buildingName!] = [];
                }
                groups[buildingName!].push(item);
                return groups;
            }, {} as Record<string, RequestResponseWithBuildingDTO[]>);
        }

        React.useEffect(() => {
            refreshData();
        }, [refreshData]);

        useImperativeHandle(ref, () => ({
            refreshData,
        }));

        if (loading) {
            return <LoadingIndicator />;
        }
        return (
            <Box>
                <MobileRequestSearch data={Object.values(requestsAll).flat()} propsToFilter={[{ name: 'text', type: 'string' }, { name: 'desription', type: 'string' }, { name: 'buildingName', type: 'string' }]} propsToSort={[{ name: 'text', displayName: t('Name') }, { name: 'datetime', displayName: t('created') }, { name: 'datetimeTo', displayName: t('Deadline') }]} setData={(res) => { setRequests(groupByBuilding(res ?? [])) }} />
                <Grid container sx={{ flex: 1, p: 0, /* height: 'calc(100vh - 145px)',  */display: 'flex', flexDirection: 'row', pb: 3 }}>
                    {!loading && Object.entries(requests).map(([buildingName, tenants]) => (
                        <Grid item xs={12} key={buildingName} style={{ overflowY: 'auto' }}>
                            <MobileRequestBuildingItem
                                key={buildingName}
                                requests={tenants} // Pass tenants (grouped items) here
                                buildingName={buildingName}
                                onRefresh={refreshData}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>);
    });

export default MobileRequestsDetailTab;
